<template>
    <div class="col-md-6 col-lg-4">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h3 class="panel-title">Editar Squad</h3>
            </div>
            <form v-on:submit.prevent="edit">
                <div class="panel-body">
                    <div class="form-group">
                        <label class="form-group" for="name">Nome</label>
                        <input class="form-control" type="text" v-model="squad.name" placeholder="Nome" name="name" id="name">
                        <span class="text-danger">{{ errors.hasOwnProperty('name') ? errors.name[0] : '' }}</span>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="teams">Equipes</label>
                        <v-select :reduce="team => team.id" label="name" v-model="teams" :options="options.teams" multiple/>
                    </div>
                    <div class="form-group">
                        <label class="form-group" for="customers">Clientes</label>
                        <v-select :reduce="customer => customer.id" label="name" v-model="customers" :options="options.customers" multiple/>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">Editar</button>
                    </div>
                </div>
            </form>
        </div>
    </div>


</template>

<script>
    import axios from 'axios'
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/pt-br';

    export default {
        name: 'squad-edit',
        props: ['squad'],
        data () {
            return {
                errors: {},
                teams: [],
                customers: [],
                options: {
                    customers:[],
                    teams: []
                }
            }
        },
        mounted () {
            this.teams = this.squad.teams_ids
            this.customers = this.squad.customers_ids
            axios
                .get('/api/teams')
                .then((response) => {
                    this.options.teams = response.data.data
                })
            axios
                .get('/api/customers')
                .then((response) => {
                    this.options.customers = response.data.data
                })
        },
        methods: {
            edit () {
                axios
                    .put('/api/squads/' + this.squad.id, {
                        name: this.squad.name,
                        customers: this.customers,
                        teams: this.teams
                    })
                    .then(() => {
                         this.$router.push({
                             name: 'squads'
                        });
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    })
            }
        }
    }
</script>


<style scoped lang="sass">
    .btn-primary
        margin-top: 30px
    .mx-datepicker
        display: block
        width: 100%
</style>
